import { render, staticRenderFns } from "./DNSTwisterSearchResultsAvailable.vue?vue&type=template&id=0beb0bdc&"
import script from "./DNSTwisterSearchResultsAvailable.vue?vue&type=script&lang=js&"
export * from "./DNSTwisterSearchResultsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports